/**
 * MUI 4.12 depreciou fade() em favor de alpha(); fade só loga e chama alpha.
 * Dependências antigas (@material-ui/pickers, @material-ui/lab, material-table)
 * ainda importam fade — este shim remove o ruído no console sem mudar o resultado.
 */
// eslint-disable-next-line import/no-commonjs, global-require
const colorManipulator = require('@material-ui/core/styles/colorManipulator');

colorManipulator.fade = colorManipulator.alpha;
